<script>
import NewsItem from './NewsItem.vue';

export default {
  components: {
    NewsItem,
  },
  props: [
    'news',
    'cPageIndex',
    'nPageIndex',
    'loading',
    'loadingMore',
    'promotedNewsItem',
    'showMore',
    'groupsText',
  ],
  data() {
    return {
      show: this.showMore,
    };
  },
  methods: {
    fetchMore() {
      this.$emit('fetch-more');
    },
  },
};
</script>

<template>
  <div class="row newslist">
    <div class="col-12">
      <ul class="list-unstyled">
        <NewsItem
          v-if="this.promotedNewsItem"
          :id="this.promotedNewsItem.UniqueId"
          :img="this.promotedNewsItem.ImageData"
          :img-alt="this.promotedNewsItem.ImageText"
          :url="this.promotedNewsItem.Url"
          :title="this.promotedNewsItem.Title"
          :excerpt="this.promotedNewsItem.Intro"
          :date="this.promotedNewsItem.PublishedDate"
          promotestyle="promotestyle"
        />
        <NewsItem
          v-for="news in this.news"
          :key="news.EventPageId"
          :id="news.UniqueId"
          :img="news.ImageData"
          :img-alt="news.ImageText"
          :groups-text="groupsText"
          :groups="news.Groups"
          :tags="news.Tags"
          :url="news.Url"
          :title="news.Title"
          :excerpt="news.Intro"
          :date="news.PublishedDate"
        />
      </ul>
    </div>
    <div
      class="col-12"
      v-if="
        this.cPageIndex < this.nPageIndex ||
        (!this.cPageIndex == this.nPageIndex && !this.loading)
      "
    >
      <transition name="fade" mode="out-in">
        <button
          key="1"
          @click="this.fetchMore"
          class="d-flex align-items-center button-small ml-auto mr-auto"
          v-if="!this.loadingMore"
        >
          {{ show }}
        </button>
        <button
          key="2"
          disabled
          class="d-flex align-items-center button-small ml-auto mr-auto"
          v-else
        >
          <i class="material-icons">cached</i>
        </button>
      </transition>
    </div>
  </div>
</template>
